import { Link, Notice, Table, Text } from "@smooth/design-system-components"
import { useRouter } from "next/router"
import { useBankTransferResults } from "../hooks/useBankTransferResults"
import Pagination from "src/components/tailwind-components/Pagination"
import { formatDateTime } from "src/features/admin/screen-shared"

const COLUMNS = [
  { key: "user", header: "User" },
  { key: "bankTransferInvoice", header: "Bank Transfer Invoice" },
  { key: "id", header: "Id" },
  { key: "paymentAt", header: "Payment At" },
]

export const BankTransferResultList = ({ page }: { page: number }) => {
  const router = useRouter()
  const { bankTransferResults, pagination, error, isLoading } = useBankTransferResults(page)

  if (error) return <Notice tone="error">一覧を取得できませんでした</Notice>
  if (isLoading) return <Text>読み込み中...</Text>

  const rows = bankTransferResults.map((result) => ({
    id:
      result.id === null ? null : (
        <Link href={`/admin/bank-transfer-results/${result.id}`}>{result.id}</Link>
      ),
    user:
      result.userId === null ? null : (
        <Link href={`/admin/users/${result.userId}`}>{result.userId}</Link>
      ),
    bankTransferInvoice:
      result.bankTransferInvoiceId === null ? null : (
        <Link href={`/admin/bank-transfer-invoices/${result.bankTransferInvoiceId}`}>
          {result.bankTransferInvoiceId}
        </Link>
      ),
    paymentAt: formatDateTime(result.paymentAt),
  }))

  return (
    <div className="flex flex-col gap-4">
      <Table
        columns={COLUMNS}
        rows={rows}
        onRowClick={(index) =>
          router.push(`/admin/bank-transfer-results/${bankTransferResults[index].id}`)
        }
      />
      <Pagination
        pagination={{
          currentPage: page,
          totalPages: pagination?.totalPages ?? 1,
          totalCount: pagination?.totalCount ?? 0,
        }}
        onPageChange={(next) => router.push({ query: { ...router.query, page: next } })}
      />
    </div>
  )
}
